import {gql} from 'graphql-tag';

export const GET_STORE_LOCATOR_SETTINGS = gql`
  query GetStoreLocatorSettings {
    getStoreLocatorSettings {
      id
      retailer
      accountManager
      createdAt
      updatedAt
    }
  }
`;